module.exports = __webpack_public_path__ + "img/center_alignac.5556349f.svg";